"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableTotal = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var _table_1 = tslib_1.__importDefault(require("../_components/_table"));
var empty_state_1 = tslib_1.__importDefault(require("../empty-state"));
var DirectionCaretDownFill_1 = require("../Icons/DirectionCaretDownFill");
var DirectionCaretRightFill_1 = require("../Icons/DirectionCaretRightFill");
var PromptCloseCircleFill_1 = require("../Icons/PromptCloseCircleFill");
var widthAnq_1 = tslib_1.__importDefault(require("../widthAnq"));
var FilterDropdown_1 = require("./FilterDropdown");
var transformSorter_1 = require("./transformSorter");
var useColumns_1 = require("./useColumns");
var useTableTotal_1 = tslib_1.__importDefault(require("./useTableTotal"));
exports.useTableTotal = useTableTotal_1.default;
var prefix = 'anq-table';
var defaultErrorNode = function (onFresh) {
    return (react_1.default.createElement("div", { className: "".concat(prefix, "-error") },
        react_1.default.createElement(PromptCloseCircleFill_1.PromptCloseCircleFill, { className: "".concat(prefix, "-error-icon") }),
        react_1.default.createElement("div", { className: "".concat(prefix, "-error-text") },
            "\u52A0\u8F7D\u5931\u8D25",
            react_1.default.createElement("a", { className: "".concat(prefix, "-error-fresh"), onClick: onFresh }, "\u5237\u65B0"))));
};
var defaultExpandIcon = function (_a) {
    var _b;
    var expanded = _a.expanded, onExpand = _a.onExpand, record = _a.record;
    var iconProps = {
        onClick: function (e) { return onExpand(record, e); },
        className: (0, classnames_1.default)('iconfont', "".concat(prefix, "-tree-icon"), (_b = {},
            _b["".concat(prefix, "-tree-icon-hide")] = !record.children,
            _b)),
    };
    if (expanded) {
        return react_1.default.createElement(DirectionCaretDownFill_1.DirectionCaretDownFill, tslib_1.__assign({}, iconProps));
    }
    return react_1.default.createElement(DirectionCaretRightFill_1.DirectionCaretRightFill, tslib_1.__assign({}, iconProps));
};
var AnqTableCp = function (props) {
    var _a;
    var loading = props.loading, loadingConfig = props.loadingConfig, errorConfig = props.errorConfig, emptyText = props.emptyText, children = props.children, columns = props.columns, dataSource = props.dataSource, expandable = props.expandable, className = props.className, useNestTable = props.useNestTable, useTypeTable = props.useTypeTable;
    var loadingParams = (0, react_1.useMemo)(function () {
        var _a = loadingConfig, loadingText = _a.loadingText, loadingIcon = _a.loadingIcon;
        return {
            wrapperClassName: "".concat(prefix, "-loading"),
            indicator: loadingIcon,
            tip: loadingText,
            spinning: loading,
        };
    }, [loading, loadingConfig]);
    var emptyNode = (0, react_1.useMemo)(function () {
        return react_1.default.createElement("div", { className: "".concat(prefix, "-empty") }, emptyText);
    }, [emptyText]);
    var errorNode = (0, react_1.useMemo)(function () {
        var _a = errorConfig, error = _a.error, errorNode = _a.errorNode, onFresh = _a.onFresh;
        if (!error) {
            return null;
        }
        return react_1.default.createElement("div", { className: "".concat(prefix, "-error-mask") }, errorNode || defaultErrorNode(onFresh));
    }, [errorConfig]);
    var mergedColumns = (0, react_1.useMemo)(function () {
        var mergedColumns = (columns ||
            (0, useColumns_1.convertChildrenToColumns)(children));
        return (0, useColumns_1.transformAnqColumns)([FilterDropdown_1.transformDefaultFilter, transformSorter_1.transformSorter], mergedColumns);
    }, [children, columns]);
    var mergedExpandable = (0, react_1.useMemo)(function () {
        if (!dataSource) {
            return expandable;
        }
        var hasChildren = dataSource.some(function (item) {
            return Array.isArray(item.children);
        });
        if (hasChildren) {
            if (!expandable) {
                return { expandIcon: defaultExpandIcon };
            }
            return tslib_1.__assign(tslib_1.__assign({}, expandable), { expandIcon: defaultExpandIcon });
        }
        return expandable;
    }, [expandable, dataSource]);
    var hasSelections = (0, react_1.useMemo)(function () {
        var _a;
        return !!((_a = props.rowSelection) === null || _a === void 0 ? void 0 : _a.selections);
    }, [props.rowSelection]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(prefix, "-box"), (_a = {},
            _a["".concat(prefix, "-stickyLoading")] = props.sticky && loading,
            _a["".concat(prefix, "-isEnableScroll")] = !!props.scroll,
            _a["".concat(prefix, "-isUnStickyAndUnScroll")] = !props.sticky && !props.scroll,
            _a)) },
        props.sticky && props.bordered ? (react_1.default.createElement("div", { className: "".concat(prefix, "-sticky-anchor-wrapper") },
            react_1.default.createElement("div", { className: "".concat(prefix, "-sticky-anchor"), style: {
                    top: props.sticky.offsetHeader || 0,
                } }))) : null,
        errorNode,
        react_1.default.createElement(_table_1.default, tslib_1.__assign({}, props, { expandable: mergedExpandable, loading: loadingParams, locale: { emptyText: emptyNode }, columns: mergedColumns, className: (0, classnames_1.default)(className, {
                'nest-table': useNestTable,
                'type-table': useTypeTable,
                'anq-table-with-selections': hasSelections,
            }) }))));
};
var AnqTable = (0, widthAnq_1.default)(AnqTableCp, {
    OriginComponent: _table_1.default,
});
AnqTableCp.defaultProps = tslib_1.__assign(tslib_1.__assign({}, _table_1.default.defaultProps), { loading: false, pagination: false, showSorterTooltip: false, emptyText: react_1.default.createElement(empty_state_1.default, null), loadingConfig: {
        loadingText: '加载中',
    }, errorConfig: {
        error: false,
        errorNode: null,
        onFresh: function () { },
    } });
AnqTable.useTableTotal = useTableTotal_1.default;
exports.default = AnqTable;
//# sourceMappingURL=index.js.map